import AppLayout from "../../components/AppLayout";
import useVariables from "../../hooks/pages/useVariables";
import TableVariables from "../../components/tables/TableVariables";
import TableSlotValues from "../../components/tables/TableSlotValues";
import ToggleTab from "../../components/tabs/ToggleTab";
import { useState } from "react";
import { TbSettingsFilled } from "react-icons/tb";
import { PiListDashesFill } from "react-icons/pi";
import NoDataMsg from "../../components/info/NoDataMsg";
import { PiListStarBold } from "react-icons/pi";
import CardContainer from "../../components/cards/CardContainer";

function Variables() {
    document.title = "Variables Entrenamiento Avanzado | Trini Talkbot";

    const [viewTypeTab, setViewTypeTab] = useState(1);

    const {
        isLoading,
        variables,
        slotsCandidates,
        values,
        setVariables,
        handleEditSlotValue,
        handleDeleteSlotValue,
        handleAddSlotValue,
    } = useVariables();

    return (
        <AppLayout
            isLoading={isLoading}
            title="Entrenamiento Avanzado"
            subtitle=""
            tab={3}
            tabType="advanced"
            dangerAlert
            warningAlert
        >
            <div className="d-flex flex-column gap-3">
                <div>
                    <ToggleTab
                        setTab={setViewTypeTab}
                        tab={viewTypeTab}
                        items={[
                            { icon: TbSettingsFilled, label: "ABM Variables", value: 1 },
                            { icon: PiListDashesFill, label: "Valores", value: 2 }
                        ]}
                    />
                </div>

                <CardContainer
                    softTitle="VARIABLES"
                    mainTitle={viewTypeTab === 1 ? "Listado de variables" : "Valores por usuario"}
                    description={
                        viewTypeTab === 1
                            ? "Aquí puedes ver todas las variables que has creado para tu chatbot. Recuerda que las variables son fundamentales para que tu chatbot pueda almacenar y utilizar información de manera efectiva."
                            : "Aquí puedes ver todos los valores de variables almacenados para cada usuario. Expande una fila para ver el detalle completo de todos sus slots."
                    }
                >
                    <div className="m-4">
                        {viewTypeTab === 1 && (
                            <div>
                                {variables && variables.length > 0 ? (
                                    <TableVariables
                                        variables={variables}
                                        setVariables={setVariables}
                                        slotsCandidates={slotsCandidates}
                                    />
                                ) : (
                                    <NoDataMsg
                                        icon={<TbSettingsFilled />}
                                        title="Sin variables"
                                        subtitle="Aún no has creado ninguna variable. Crea una para poder usarla en tus conversaciones."
                                    />
                                )}
                            </div>
                        )}
                        {viewTypeTab === 2 && (
                            <div>
                                {values && values.length > 0 ? (
                                    <TableSlotValues
                                        data={values}
                                        onEditSlotValue={handleEditSlotValue}
                                        onDeleteSlotValue={handleDeleteSlotValue}
                                        onAddSlotValue={handleAddSlotValue}
                                        variables={variables}
                                    />
                                ) : (
                                    <NoDataMsg
                                        icon={<PiListStarBold />}
                                        title="Sin valores"
                                        subtitle="Aún no hay valores de variables almacenados para los usuarios."
                                    />
                                )}
                            </div>
                        )}
                    </div>
                </CardContainer>
            </div>
        </AppLayout>
    );
}

export default Variables;